import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';

export const noCacheInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  if (req.method !== 'GET' || req.url.startsWith('/assets/')) {
    return next(req);
  }
  return next(req.clone({
    setHeaders: {
      'Cache-Control': 'no-cache, no-store',
      'Pragma': 'no-cache',
    },
  }));
};
